<template>
    <div class="CreateBomVariantFormComponent">


        {{lang.label_Name}}:
        <b-form-input  v-if="variantsOptions.length == 1" id="inputNameBom" size="sm" class="form-control inputNameBom" v-model="form.name" :placeholder="lang.placeholder_Name" type="text"></b-form-input>

        <b-form-select v-if="variantsOptions.length > 1" size="sm" class="select-variant" v-model="form.name" :options="variantsOptions"></b-form-select>
        <br>
        {{lang.label_BomNumber}}:
        <b-form-input  v-if="variantsOptions.length == 1" id="inputBomNumber" size="sm" class="form-control inputBomNumber" v-model="form.bomNumber" :placeholder="lang.placeholder_inputBomNumber" type="text"></b-form-input>
        <br>
        {{lang.label_Description}}:
        <b-form-textarea id="textareaDescriptionBom" v-model="form.description" rows="3"
            max-rows="6" size="sm" class="form-control textarea-descr"></b-form-textarea>



    </div>
</template>

<script>


export default {
    name: "CreateBomVariantFormComponent",
    components: {



    },
    props: {
        lang: Object
    },
    data() {
        return {
            form: {
                name: null,
                description: ""

            },
            variantsOptions: [
                
            ]
        }
    },
    computed: {
                
    },
    created() {
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_createBomVariantForm", this.form)
        this.getVariants();
    },
    updated() {

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_createBomVariantForm", this.form)

    },
    methods: {
        getVariants() {

            this.variantsOptions = [
                {
                    value: null,
                    text: "Choose...",

                }
            ];

            const variants = this.$store.getters.variants;

            for (let i = 0, lei = variants.length; i < lei; i++) {



                let obj = {
                    value: variants[i].name,
                    text: variants[i].name,

                }
                this.variantsOptions.push(obj);
            }

                     


        },
    }
}
</script>
<style lang="scss">
    .CreateBomVariantFormComponent {
        
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/CreateBomVariantFormComponent.vue